// extracted by mini-css-extract-plugin
export default {"avatarCon":"index_avatarCon__3MNcl","dot":"index_dot__HYgi8","bigDot":"index_bigDot__+B-3E","online":"index_online__iNtBz","offline":"index_offline__w2sKL"};